import { createEntityAdapter, createSlice } from '@reduxjs/toolkit'
import { find } from 'lodash-es'
import ActionTypes from '@constants/action_types.js'

const gridViewsAdapter = createEntityAdapter()

// create initial state for the views slice and include a view to act as the default view
const initialState = gridViewsAdapter.getInitialState({
  ids: [],
  entities: {},
})

const slice = createSlice({
  name: 'gridViews',
  initialState,
  extraReducers: builder => {
    builder.addCase(ActionTypes.RECEIVE_ENTITIES, (state, action) => {
      const { payload } = action
      if (payload.hasOwnProperty('grid_views')) {
        gridViewsAdapter.upsertMany(state, payload.grid_views)
      }
    })
  },
})

// Selectors

export const gridViewsSelectors = gridViewsAdapter.getSelectors(state => state.data.gridViews)

export const getGridView = (state, props) => {
  const { gridViewId } = props
  const allEntities = gridViewsSelectors.selectAll(state)
  return find(allEntities, entity => {
    const result = entity.id.toString() === gridViewId.toString()
    return result
  })
}

export default slice.reducer
